module.exports = __webpack_public_path__ + "static/media/gokrisp-baies.8af559b2.png";